import {CustomerContact} from '../customer-contact.model';
import {Address} from '../../../address/models/address.model';
import {CustomerIdentification} from '../customer-identification.model';
import {CustomerName} from '../customer-name.model';

export class SimpleCustomer  {

    public id: number;
    public dateOfBirth: any;
    public name: CustomerName;
    public ssn: CustomerIdentification;
    public personalCell: CustomerContact;
    public personalEmail: CustomerContact;
    public individualAddress: Address;
    public override: boolean;

}
